import React from "react";
import CameraStream from "../../Streaming/Video/CameraStream";
import "./PlaybackVideo.css";
import trans from "../../../utils";

const PlaybackVideo = React.memo(({ 
  selectedVehicle, 
  selectedChannel, 
  selectedSegment, 
  playbackUrl,
  isLoadingPlayback,
  isPlaying, 
  setIsPlaying 
}) => {
  if (!selectedVehicle || !selectedChannel || !selectedSegment) {
    return (
      <div className="playback-video-placeholder">
        <div className="placeholder-content">
          <div className="placeholder-play-icon">▶</div>
          <div className="placeholder-text">{trans("Select a segment to play")}</div>
        </div>
      </div>
    );
  }

  if (isLoadingPlayback) {
    return (
      <div className="playback-video-placeholder">
        <div className="placeholder-content">
          <div className="placeholder-text">{trans("Loading playback...")}</div>
        </div>
      </div>
    );
  }

  if (!playbackUrl) {
    return (
      <div className="playback-video-placeholder">
        <div className="placeholder-content">
          <div className="placeholder-text">{trans("Preparing video...")}</div>
        </div>
      </div>
    );
  }

  const videoTitle = `${selectedVehicle.name} - ${selectedChannel.name} (${selectedSegment.startTime} - ${selectedSegment.endTime})`;

  return (
    <div className="playback-video-wrapper">
      <div className="playback-video-header">
        <div className="video-title">{videoTitle}</div>
      </div>
      <div className="playback-video-content">
        <CameraStream hlsUrl={playbackUrl} isPlaying={isPlaying} mode="playback" />
      </div>
    </div>
  );
});

export default PlaybackVideo;
